<template>
    <div :class="$style.container">
        <div :class="[$style.circle, $style.loading]" />
        <div :class="$style.verticalGroup">
            <div :class="[$style.sousageTop, $style.loading]" />
            <div :class="[$style.sousageBottom, $style.loading]" />
        </div>
        <div :class="[$style.button, $style.loading]" />
    </div>
</template>

<style module>
.container {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    border-radius: 26px;
    padding: 0;
    gap: 8px;
    height: 36px;
    justify-content: space-between;
}

.circle {
    width: 36px;
    height: 36px;
    border-radius: 18px;
    background-color: var(--white-08);
}
.button {
    width: 64px;
    height: 36px;
    border-radius: 18px;
    background-color: var(--white-08);
}

.verticalGroup {
    display: flex;
    flex-direction: column;
    flex-grow: 3;
    gap: 4px;
}

.sousageTop {
    height: 12px;
    border-radius: 6px;
    width: 48px;
    background-color: var(--white-08);
}

.sousageBottom {
    height: 12px;
    border-radius: 6px;
    width: 100%;
    background-color: var(--white-08);
}

@keyframes blink {
    0% {
        background-color: var(--white-08);
    }

    38% {
        background-color: var(--white-16);
    }

    50% {
        background-color: var(--white-16);
    }

    88% {
        background-color: var(--white-08);
    }

    100% {
        background-color: var(--white-08);
    }
}

.loading {
    animation: blink 1.4s infinite;
}
</style>
